import React, { useEffect, useState } from "react";
import { useCatalog } from "../lib/catalog-context";
import { listPortfolioFeatured } from "../lib/api";
import ServiceTile from "../components/shared/ServiceTile";
import { SkeletonImage } from "../components/shared/Skeleton";
import EmptyState from "../components/shared/EmptyState";
import { t } from "../lib/i18n";

export default function ServicesList() {
  const { services, loading } = useCatalog();
  const [covers, setCovers] = useState({});

  useEffect(() => {
    if (!services?.length) return undefined;
    let cancelled = false;
    (async () => {
      const entries = await Promise.all(
        services.map(async (svc) => {
          try {
            const imgs = await listPortfolioFeatured({ service_id: svc.id, limit: 1 });
            return [svc.id, imgs[0] || null];
          } catch {
            return [svc.id, null];
          }
        }),
      );
      if (!cancelled) setCovers(Object.fromEntries(entries));
    })();
    return () => {
      cancelled = true;
    };
  }, [services]);

  return (
    <section
      data-testid="services-list-page"
      className="mx-auto max-w-6xl px-5 pt-20 pb-24 sm:px-6 sm:pt-28"
    >
      <p className="mb-4 text-xs uppercase tracking-[0.32em] text-[#C8A24B]">
        {t("brand.name")}
      </p>
      <h1 className="font-display text-4xl text-[#1A1A1A] sm:text-5xl lg:text-6xl">
        {t("servicesList.title")}
      </h1>
      <p className="mt-4 max-w-xl text-base text-[#1A1A1A]/65">
        {t("servicesList.subtitle")}
      </p>

      <div className="mt-12">
        {loading ? (
          <ul className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {[0, 1, 2].map((i) => (
              <li key={i}>
                <SkeletonImage className="aspect-[4/5] w-full" />
              </li>
            ))}
          </ul>
        ) : !services?.length ? (
          <EmptyState title="Services coming soon" testid="services-list-empty" />
        ) : (
          <ul
            data-testid="services-list-grid"
            className="grid grid-cols-1 gap-6 md:grid-cols-3"
          >
            {services.map((svc) => (
              <li key={svc.id}>
                <div>
                  <ServiceTile service={svc} coverImage={covers[svc.id]} size="lg" />
                  <p className="mt-4 text-sm leading-relaxed text-[#1A1A1A]/65">
                    {svc.description}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
